import React from 'react'
import { Table, Row, Col } from 'react-bootstrap'
import Input from './input'
import ReactMixin from 'react-mixin'
import ImmutableRenderMixin from 'react-immutable-render-mixin'

/**
 * Display / Editable table
 */
@ReactMixin.decorate(ImmutableRenderMixin)
class PersonalMapping extends React.Component {
  static propTypes = {
    account: React.PropTypes.object.isRequired,
    type: React.PropTypes.string.isRequired,
    link: React.PropTypes.func.isRequired,
    mapping: React.PropTypes.object,
    data: React.PropTypes.object,
    editable: React.PropTypes.bool
  }

  renderCol (col) {
    return col.map(m => ([
      (<h5>{m.get('label')}</h5>),
      this.renderTable(m.get('fields'))
    ]))
  }

  renderLabel (label) {
    return (
      <td width="175">{label}</td>
    )
  }

  renderTable (fields) {
    const { link, editable, data } = this.props

    return (
      <Table bordered className="redi-component-editable-table">
        <tbody>
          {fields.map((field, key) => (
            <tr key={key}>
              {this.renderLabel(field.get('label'))}
              <td className="redi-component-editable">
                {editable
                    ? <Input
                        name={field.get('fid')}
                        type={field.get('type').toLowerCase()}
                        valueLink={link(`customFlds.${field.get('fid')}`)} />
                    : data && data.get(field.get('fid'))
                }
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    )
  }

  render() {
    const { mapping, account, editable, type } = this.props
    const isGroupAdmin = account.get('isGroupAdmin')
    const link = `/personal/${type}`

    if (!mapping && !isGroupAdmin) return null

    return (
      <div>
        <h5><b>Personal Data</b> {editable && isGroupAdmin && <a href={link}>(edit fields)</a>}</h5>
        {mapping &&
          <Row>
            <Col xs={6}>
              {this.renderCol(mapping.get('col1'))}
            </Col>

            <Col xs={6}>
              {this.renderCol(mapping.get('col2'))}
            </Col>
          </Row>
        }
        {!mapping &&
          <p>No personal data fields exist. <a href={link}>Create personal data fields</a>.</p>
        }
      </div>
    )
  }
}

export default PersonalMapping



// WEBPACK FOOTER //
// ./modules/shared/components/personalMapping.js